if (!customElements.get('tab-section')) {
  customElements.define('tab-section', class TabSection extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('.tabs__button[role="tab"]');
      this.panels = this.querySelectorAll('.tabs__panel');
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => this.selectTab(btn));
      });
    }

    selectTab(selected) {
      this.buttons.forEach(btn => {
        const isSelected = btn === selected;
        btn.classList.toggle('is-active', isSelected);
        btn.setAttribute('aria-selected', isSelected);
      });

      const targetId = selected.getAttribute('aria-controls');
      this.panels.forEach(panel => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }
  });
}
